export const ADMIN = 'admin';
export const GUEST = 'guest';



// WEBPACK FOOTER //
// ./src/sources/constants/userRoles.js